import {NgModule} from "@angular/core";
import {IntRadioComponent} from "./int-radio.component";
import {CommonModule} from "@angular/common";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule
  ],
  declarations: [
    IntRadioComponent
  ],
  exports: [
    IntRadioComponent
  ]
})
export class IntRadioModule {}